import { all } from 'redux-saga/effects'
import formSagas from './Form'
import responseSagas from './Response'

export default function* rootSaga(getState) {
  yield all([
    formSagas(),
    responseSagas(),
  ])
}
